export const MODAL_SIZE = {
  fullWidth: '100vw',
  fullHeight: '100vh',
  largeWidth: '48vw',
  largeHeight: '48vh',
  mediumWidth: '608px',
  smallWidth: '480px',
  smallHeight: '320px',
  smallWidthAlt: '456px',
  xSmallHeight: '240px',
  xSmallHeightAlt: '260px',
};

export interface IModalSize {
  width: string;
  height?: string;
}
